var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#06255C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7631 60.9869V57.4342C62.7631 54.1235 60.4987 51.3416 57.4342 50.5528M51.2171 29.5297C53.821 30.5837 55.6579 33.1366 55.6579 36.1184C55.6579 39.1003 53.821 41.6532 51.2171 42.7072M53.8816 60.9869C53.8816 57.6762 53.8816 56.0209 53.3407 54.7152C52.6196 52.9742 51.2363 51.591 49.4954 50.8698C48.1896 50.329 46.5343 50.329 43.2237 50.329H37.8947C34.5841 50.329 32.9288 50.329 31.623 50.8698C29.882 51.591 28.4988 52.9742 27.7777 54.7152C27.2368 56.0209 27.2368 57.6762 27.2368 60.9869M47.6644 36.1184C47.6644 40.0426 44.4833 43.2237 40.5592 43.2237C36.6351 43.2237 33.4539 40.0426 33.4539 36.1184C33.4539 32.1943 36.6351 29.0132 40.5592 29.0132C44.4833 29.0132 47.6644 32.1943 47.6644 36.1184Z",
    stroke: "white",
    strokeWidth: 3.94737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersHover);
export default __webpack_public_path__ + "static/media/users-hover.ca7d549569371ac57cb89e934ad5150d.svg";
export { ForwardRef as ReactComponent };